import { preparePhone } from '@/helpers/functions'
import Repository from './Repository'

const action = 'managers'

export default {
  getList() {
    return Repository.get(action)
  },
  postItem(data) {
    data.login = preparePhone(data.login)

    return Repository.post(action, { ...data })
  },
  updateItem(id, data) {
    data.login = preparePhone(data.login)

    return Repository.put(`${action}/${id}`, { ...data })
  },
  deleteItem(id) {
    return Repository.delete(`${action}/${id}`)
  },
}
